import { Component } from '@theme/component';

/**
 * The Collection page's hover list (`sections/collection-explorer.liquid`). Hovering or focusing a
 * name makes it the active one: full strength, its arrow showing, its image crossfaded into the
 * preview, and the preview's "Explore" pointed at it.
 *
 * Purely an enhancement. Every name is a real link, the first item is active in the markup, and on
 * touch screens the preview is not shown at all.
 *
 * @typedef {Object} ExplorerRefs
 * @property {HTMLAnchorElement[]} [links]
 * @property {HTMLElement[]} [slides]
 * @property {HTMLElement} [title]
 * @property {HTMLAnchorElement} [explore]
 *
 * @extends {Component<ExplorerRefs>}
 */
class CollectionExplorer extends Component {
  /**
   * @param {Event} event
   * @returns {void}
   */
  select(event) {
    const link = event.target instanceof Element ? event.target.closest('.collection-explorer__link') : null;
    if (!(link instanceof HTMLAnchorElement)) return;

    const index = Number(link.dataset.index);
    if (!Number.isInteger(index)) return;

    for (const item of this.refs.links ?? []) item.toggleAttribute('data-active', item === link);
    (this.refs.slides ?? []).forEach((slide, i) => slide.toggleAttribute('data-active', i === index));

    if (this.refs.title) this.refs.title.textContent = link.dataset.title ?? '';
    if (this.refs.explore) this.refs.explore.href = link.href;
  }
}

if (!customElements.get('collection-explorer')) {
  customElements.define('collection-explorer', CollectionExplorer);
}
